import { render, staticRenderFns } from "./WTLeftMenu.vue?vue&type=template&id=b0666702&scoped=true"
import script from "./WTLeftMenu.vue?vue&type=script&lang=js"
export * from "./WTLeftMenu.vue?vue&type=script&lang=js"
import style0 from "./WTLeftMenu.vue?vue&type=style&index=0&id=b0666702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0666702",
  null
  
)

export default component.exports